module.exports = __webpack_public_path__ + "static/makook_apps-8cdc3f3011b64f232d99d959a4d17d97.mp4";